<template>
  <div class="data-container">
    <div class="data-item">
      <div class="data-label">ID</div>
      <div>
        <el-input
          :value="id"
          controls-position="right"
          size="mini"
          readonly
          placeholder=""
        ></el-input>
      </div>
    </div>
    <div class="data-item">
      <div class="data-label">Name</div>
      <div>
        <el-input
          v-model="name"
          controls-position="right"
          size="mini"
          placeholder=""
        ></el-input>
      </div>
    </div>
    <!-- 添加tag -->
    <div class="data-item">
      <div class="data-label">
        Tag
        <el-tooltip placement="top">
          <div slot="content">Tag 用于标识数据，可在事件等地方通过tag直接获取到当前组件信息</div>
          <i class="el-icon-warning"></i>
        </el-tooltip>
      </div>
      <div>
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          class="tag-item"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          {{ tag }}
        </el-tag>
        <el-input
          class="input-new-tag tag-item"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button
          v-else
          class="button-new-tag tag-item"
          size="small"
          @click="showInput"
          >+ New Tag</el-button
        >
      </div>
    </div>

    <!-- 数据start -->
    <strong>添加数据</strong>
    <hr />
    <data-list></data-list>
    <!-- 数据 end -->
  </div>
</template>
<script>
import { dataType } from "../../types/sprite-types";
import DataList from "./data-list.vue";
export default {
  components: {
    DataList,
  },
  data() {
    return {
      id: "",
      dynamicTags: [],
      name: "",
      inputVisible: false,
      inputValue: "",
      dataType,
      dialogFormVisible: false,
      dataProps: [],
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.init();
  },
  destroyed() {
    this.saveConfig();
  },
  methods: {
    // 初始化
    init() {
      if (this.topo.store && this.topo.store.active.length == 1) {
        this.active = this.topo.store.active[0];
      }

      if (!this.active) return;
      this.id = this.active.id;
      this.name = this.active.alias || "";
      this.dynamicTags = this.active.tags || [];
      this.customProps = this.active.customProps || [];
    },

    // 保存配置
    saveConfig() {
      if (!this.active) return;
      this.active.tags = this.dynamicTags;
      this.active.id = this.id;
      this.active.alias = this.name; //别名
      // this.topo.stageCanvas.setValue(this.active);
    },

    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    // 心事添加tag的输入框
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    // 确认tag
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue.length > 50) {
        return this.$message.error("标签长度不能超过50个字符");
      }
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.data-container {
  .data-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .data-label {
      width: 120px;
    }
  }
  .info-content {
    display: flex;
    align-items: center;
    .enter-info {
      width: 250px;
      margin-right: 15px;
    }
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
}
</style>